<div class="form-group position-relative mb-0" [ngClass]="{ 'd-flex flex-row align-items-center': horizontal }">
    @if (label) {
        <label class="d-block" [class.me-3]="horizontal" [class.mb-0]="horizontal" [class.mb-1]="!horizontal">{{ label }}</label>
    }

    <div class="input-group">
        <input
            class="form-control"
            type="text"
            bsDaterangepicker
            #calendar="bsDaterangepicker"
            [ngClass]="size ? 'form-control-' + size : null"
            [placeholder]="placeholder"
            [isDisabled]="isDisabled"
            [maxDate]="maxDate"
            [bsConfig]="{ dateInputFormat: dateFormat, adaptivePosition: true }"
            (bsValueChange)="onChange($event)" />

        <button class="btn btn-outline calendar" type="button" (click)="calendar.toggle()"></button>
    </div>
</div>
